"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageCard = exports.readablePolicyStatus = exports.getPolicyStatusBadgeType = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../theme/colors");
var badge_1 = require("../badge");
var card_1 = require("../card");
var coverage_definition_list_1 = require("../coverage-definition-list");
var icon_button_1 = require("../icon-button");
var padding_1 = require("../padding");
var spacing_1 = require("../spacing");
var text_1 = require("../text");
var text_eyebrow_1 = require("../text-eyebrow");
var statusToBadgeMap = new Map([
    ['ACTIVE', 'success'],
    ['CANCELLED', 'danger'],
    ['EXPIRED', 'secondary'],
    ['UPCOMING', 'info'],
]);
function getPolicyStatusBadgeType(status) {
    var badgeType = statusToBadgeMap.get(status);
    if (badgeType) {
        return badgeType;
    }
    return 'primary';
}
exports.getPolicyStatusBadgeType = getPolicyStatusBadgeType;
function readablePolicyStatus(status) {
    var statusStr = status.toLowerCase();
    statusStr = statusStr.charAt(0).toUpperCase() + statusStr.slice(1);
    return statusStr;
}
exports.readablePolicyStatus = readablePolicyStatus;
function CoverageCard(_a) {
    var enrichedLineOfCoverage = _a.enrichedLineOfCoverage, _b = _a.hideTitle, hideTitle = _b === void 0 ? false : _b, _c = _a.showStatus, showStatus = _c === void 0 ? false : _c, onRemove = _a.onRemove;
    var displayName = enrichedLineOfCoverage.displayName;
    var status = enrichedLineOfCoverage.policy.status;
    return (react_1.default.createElement(card_1.Card, { hasShadow: false },
        react_1.default.createElement(padding_1.Padding, { size: 24, style: { position: 'relative' } },
            react_1.default.createElement(text_eyebrow_1.TextEyebrow, { color: colors_1.colors.peach[500] }, "Line of Coverage"),
            react_1.default.createElement(spacing_1.Spacing, { height: 4 }),
            react_1.default.createElement(text_1.Text, { weight: 600 }, displayName),
            react_1.default.createElement(spacing_1.Spacing, { height: 24 }),
            react_1.default.createElement(coverage_definition_list_1.CoverageDefinitionList, { coverageDefinition: enrichedLineOfCoverage, hideTitle: hideTitle }),
            showStatus ? (react_1.default.createElement(BadgeContainer, null,
                react_1.default.createElement(badge_1.Badge, { type: getPolicyStatusBadgeType(status) }, readablePolicyStatus(status)))) : null,
            onRemove && (react_1.default.createElement(ActionButtonContainer, null,
                react_1.default.createElement(icon_button_1.IconButton, { type: "close", onClick: function () { return onRemove(enrichedLineOfCoverage); } }))))));
}
exports.CoverageCard = CoverageCard;
var ActionButtonContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n"], ["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n"])));
var BadgeContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  position: absolute;\n  top: 24px;\n  right: 24px;\n"], ["\n  position: absolute;\n  top: 24px;\n  right: 24px;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map